module.exports = __webpack_public_path__ + "img/BM.6cad593d.svg";